export default __webpack_public_path__ + "static/media/ellip_heart.507bca5a.svg";